import { useCallback } from "react";
import { UserAccountApi, useAPIAction } from "melco-shared-logic";

export const useSwitchPaymentMode = (userIdToSwitchPaymentMode?: string, paymentMode?: number) => {

    const [switchPaymentMode] = useAPIAction(

        UserAccountApi,
        async (api: UserAccountApi) => {
            const data = await api.accountPayment({
                id: userIdToSwitchPaymentMode ?? "",
                melcoModelsChangePaymentMode: {
                    payment_mode: paymentMode
                },
            });

            return {
                successMessages: [{ message: "default" },],
                data,
            };
        },
        {
            translationPrefix: "users.actions.switch_payment_mode",
        }
    );

    return useCallback(
        async () => {

            await switchPaymentMode();


            return { success: true };
        },
        [switchPaymentMode]
    );
};
